import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryInvoicesSetting implements MutableValue {
  public isNew = true;

  private fValue?: string;

  constructor(private fId: string, private fName: string) {
    [fId, fName].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get name(): string {
    return this.fName;
  }

  get value(): string | undefined {
    return this.fValue;
  }
}
